import { Component, Input } from '@angular/core';

@Component({
  selector: 'aprova-loading-bar',
  standalone: true,
  imports: [],
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
})
export class LoadingBarComponent {
  @Input()
  public title: string = '';
}
